@for (registration of _registrations(); track registration.uId) {
  <div class="flex flex-row gap-2 w-full">
    <hs-form-field class="w-1/3">
      <hs-form-label>Id</hs-form-label>
      <hs-select
        [options]="getOptionsForRegistration(registration)"
        [selectedValue]="getRegistrationValue(registration.registrationType!)"
        (selectionChanged)="onRegistrationTypeChanged(registration.uId, $event.value)"
      ></hs-select>
    </hs-form-field>

    <hs-form-field class="w-2/3">
      <hs-form-label>{{ valueFieldLabel }}</hs-form-label>
      <input
        hsInput
        [value]="registration.registrationNumber"
        [placeholder]="valueFieldLabel"
        [invalid]="isDuplicate(registration.uId)"
        [dirty]="isDuplicate(registration.uId)"
        [touched]="isDuplicate(registration.uId)"
        [errors]="isDuplicate(registration.uId) ? [{ message: 'Diese Kundennummer existiert bereits' }] : []"
        (change)="
          onRegistrationValueChanged(
            registration.uId,
            $any($event.target).value
          )
        "
      />
    </hs-form-field>
  </div>
}

<span class="flex-1"></span>

<div class="flex flex-row justify-end p-1">
  @if (registrationOptions().length > 0) {
    <button
      hsButton
      [hsButtonSize]="'sm'"
      [hsButtonVariant]="'text'"
      (click)="onAddRegistrationClicked()"
    >
      + {{ addRegistrationLabel }}
    </button>
  }
</div>
